import { render, staticRenderFns } from "./pessai.vue?vue&type=template&id=1ef91b1e&scoped=true&"
import script from "./pessai.vue?vue&type=script&lang=js&"
export * from "./pessai.vue?vue&type=script&lang=js&"
import style0 from "./pessai.vue?vue&type=style&index=0&id=1ef91b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef91b1e",
  null
  
)

export default component.exports